export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 10_00.04fc0c9a.jpg";